import styled from 'styled-components'

const MenuItemElement = styled.div`
  padding: 0.5rem 1rem;
  cursor: pointer;

  &:hover {
    background-color: #f1f1f1;
  }
`
export default MenuItemElement
